import { InvoiceSettingsForm } from '../../../types/invoiceSettingsForm'

export const invoiceSettingsFormFieldsToDebounce: (keyof InvoiceSettingsForm)[] = [
  'contactEmail',
  'contactFirstName',
  'contactLastName',
  'contactPhone',
  'footerNote',
  'message',
  'paymentMethods',
  'termsAndConditions',
]
